import { css } from 'lit';
import { fsDesignToken } from './core/style-util.js';

export const globalStyle = css`
  [hidden],
  .hidden {
    display: none;
  }

  .button-container {
    margin: 1em;
    text-align: center;
  }

  fs-phone-number-field,
  fs-currency-field,
  fs-ssn-field,
  fs-text-field,
  fs-select {
    margin: 1em 0;
  }

  .includes-error-message {
    margin-bottom: 0;
  }

  div > fs-radio {
    margin: 1em 0;
  }

  fs-body-text {
    margin-bottom: 1em;
  }

  .callout {
    background-color: ${fsDesignToken('fsColorDigitalGray5')};
    margin: 1em 0;
    padding: 0.5em;
    text-align: left;
  }
`;
